Vue.component('dashboard', require('./Dashboard').default);

// Widgets
Vue.component('review-sites-overview-widget', require('./widgets/ReviewSitesOverviewWidget').default);
Vue.component('invites-overview-widget', require('./widgets/InvitesOverviewWidget').default);
Vue.component('recent-reviews-widget', require('./widgets/RecentReviewsWidget').default);
Vue.component('stars-overview-widget', require('./widgets/StarsOverviewWidget').default);
Vue.component('nps-overview-widget', require('./widgets/NpsOverviewWidget').default);
Vue.component('invites-overview-widget-interval', require('./widgets/InvitesOverviewWidgetInterval').default);
Vue.component('recommendations-facebook-widget', require('./widgets/RecommendationsFacebookWidget').default);

Vue.component('review-widget-grid', require('./widgets/ReviewWidgetGrid').default);
